import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDialog } from '../../redux/slices/toastSlice'
import { IDialog } from '../../types/Toast'

export default function DialogAlert(): JSX.Element {
  const dialog: IDialog = useDialog()

  const [dialogState, setDialog] = useState<IDialog | undefined>(undefined)
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleOk = () => {
    if (!dialogState || !dialogState.handleOkButton) {
      handleClose()
      return
    }
    dialogState.handleOkButton()
    handleClose()
  }

  useEffect(() => {
    if (!dialog?.content && !dialog?.title) {
      return
    }
    setDialog(dialog)
    setOpen(true)
  }, [dialog])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {dialogState?.title && (
        <DialogTitle id="alert-dialog-title">{dialogState.title}</DialogTitle>
      )}
      {dialogState?.content && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogState?.content}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={handleOk} color="primary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}
